import styles from '../styles/gnb.scss';

export function setPcbang(wrapper: HTMLElement, active?: boolean | null): void {
  const activeIcon = wrapper.querySelector<HTMLDivElement>(
    `.${styles.pcbangOn}`
  );
  const inactiveIcon = wrapper.querySelector<HTMLDivElement>(
    `.${styles.pcbangOff}`
  );

  if (!activeIcon || !inactiveIcon) return;

  if (active === true) {
    activeIcon.style.display = '';
    inactiveIcon.style.display = 'none';
  } else if (active === false) {
    activeIcon.style.display = 'none';
    inactiveIcon.style.display = '';
  } else {
    activeIcon.style.display = 'none';
    inactiveIcon.style.display = 'none';
  }
}
